import { render, staticRenderFns } from "./Sunset.vue?vue&type=template&id=2a25247d&"
import script from "./Sunset.vue?vue&type=script&lang=js&"
export * from "./Sunset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports